import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { RentingService } from 'src/app/services/renting.service';
import { UserServiceService } from 'src/app/services/user-service.service';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';
import { RentingMessageComponent } from 'src/app/shared/renting-message/renting-message.component';

@Component({
  selector: 'app-latest-orders',
  templateUrl: './latest-orders.component.html',
  styleUrls: ['./latest-orders.component.scss']
})
export class LatestOrdersComponent implements OnInit {
  public orders = []

  public columns :string[]=[];

  @Input() rentings:any[]=[];
  @Input() users:any=[];
  @Input() cars:any=[];

  @Input() type:any=""
  constructor(
    private locationService:RentingService,
    private userService:UserServiceService,
    private carService:VehiculeserviceService,
    public appService:AppService,
    public router: Router,

  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData()
  {
    if(this.type=="renting")
    {
      this.columns = ['Debut', 'Fin', 'price', 'status','lodger', 'actions'];
    }
    else if(this.type=="user")
    {
      this.columns = ["Nom","Email","Telephone","Location","Actions"];
    }
    else  if(this.type=="car"){
      this.columns = ["Marque","Model","Prix","Statut","Actions"];
    }  
  }

  public viewRenting(idRenting: number) {

    let renting = this.rentings.find((res: any) => res.id == idRenting);
   
    let obj = {
      'idRenting': idRenting,
      'status': renting.renting_status,
      'message': renting.renting_message,
      'key': 'lodger',
    }
    
		this.appService.openDialogGalsenMessage(RentingMessageComponent, obj, 'theme-dialog');
			 
  }

  public showCar(id:number)
  {
    this.router.navigate(["admin/vehicules/show-car"],{
      queryParams: { vehicule: id },
    })
  }

  public listUser()
  {
    this.router.navigate(["/admin/users"])
  }

}
